import {useState, useCallback, useMemo} from 'react';
import {MediaUploadStatus} from './MediaComponents.type';

export const useMediaComponents = () => {
  const [uploadStatus, setUploadStatus] = useState<MediaUploadStatus>({
    image: false,
    video: false,
  });

  const updateUploadStatus = useCallback(
    (mediaType: 'image' | 'video', isUploading: boolean) => {
      setUploadStatus((prev) => {
        if (prev[mediaType] === isUploading) {
          return prev;
        }
        return {
          ...prev,
          [mediaType]: isUploading,
        };
      });
    },
    [],
  );

  const isAnyUploading = useMemo(() => {
    return uploadStatus.image || uploadStatus.video;
  }, [uploadStatus.image, uploadStatus.video]);

  const uploadingMediaTypes = useMemo(() => {
    const types: string[] = [];
    if (uploadStatus.image) types.push('imagem');
    if (uploadStatus.video) types.push('vídeo');
    return types;
  }, [uploadStatus.image, uploadStatus.video]);

  return {
    uploadStatus,
    updateUploadStatus,
    isAnyUploading,
    uploadingMediaTypes,
  };
};
